import QuoteHeaderCard from './QuoteHeaderCard'

export type { QuoteHeaderCardProps } from './QuoteHeaderCard'
export default QuoteHeaderCard
